import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { destinationProp } from '../../types';
import { InitiateRedirection, RedirectionAction, RedirectionFailedAction } from '../actions';

@Injectable()
export class RedirectionEffects {
  constructor(private actions$: Actions, private store: Store) {}

  initiateRedirection$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(InitiateRedirection),
        map((action) => {
          const destination = (action.redirectionParams[destinationProp] as string)?.toLocaleLowerCase();

          if (!destination) {
            this.store.dispatch(RedirectionFailedAction({ destination: null, redirectionData: null }));
            return;
          }

          const redirectionDataArray = Object.entries(action.redirectionParams).filter(
            ([key, _]) => key !== destinationProp
          );

          const redirectionData = redirectionDataArray.reduce((result, [key, value]) => {
            return { ...result, [key]: value };
          }, {});

          this.store.dispatch(RedirectionAction({ destination, redirectionData }));
        })
      ),
    { dispatch: false }
  );
}
